module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_for')) + ": " + _vm._s(_vm.name))]), _vm._v(" "), (_vm.loyaltyProgramsEnabled) ? _c('div', {
    staticClass: "section-bottom"
  }, _vm._l((_vm.loyaltyProgramsList), function(item) {
    return _c('span', {
      staticClass: "payment-item-margin"
    }, [_c('p', {
      style: (_vm.loyaltyStyle(item))
    }, [_vm._v(_vm._s(_vm.locale.t('label_loyalty')) + " " + _vm._s(_vm.user.paidMonthsInRow > item ? item : _vm.user.paidMonthsInRow) + "/" + _vm._s(item))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addPayment()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_payment_add_new')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_price')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_number_of_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_partner')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_equipment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_comment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedPayments), function(payment) {
    return _c('tr', [_c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_from')
      }
    }, [_vm._v(" " + _vm._s(_vm.formatDate(payment.paidDate)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_to')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(payment.expireDate)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_date')
      }
    }, [_vm._v(_vm._s(payment.paidTimestamp != null ? _vm.formatDate(payment.paidTimestamp) : '/'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_mp_name')
      }
    }, [_vm._v(_vm._s(payment.membershipPackageName != null ? payment.membershipPackageName : '/'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_price')
      }
    }, [_vm._v(_vm._s(payment.paidMoney))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_number_of_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingNumber))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_type_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingTypes))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_partner')
      }
    }, [_vm._v(_vm._s(payment.isForCompany ? 'Da' : 'Ne'))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_equipment')
      }
    }, [_vm._v(_vm._s((payment.additionalKit === null || payment.additionalKit.length === 0 ? '/' : payment.additionalKit)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_payment_comment')
      }
    }, [_vm._v(_vm._s((payment.comment == null || payment.comment.length === 0 ? '/' : payment.comment)))]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_edit')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editPayment(payment.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                                ")])]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(payment)),
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deletePayment(payment.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                                ")])])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-646da4e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Payment/UserPayment.vue
// module id = 777
// module chunks = 0